//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';

export default Vue.extend({
  name: 'ErrorPage',

  layout: 'base',

  head() {
    return {
      title: `Error${this.$config.PageTitleDefaultSuffix}`
    };
  },

  props: {
    error: { type: Object, required: true }
  },

  created() {
    // Application Insights doesn't auto-collect and report 'page not found' errors,
    // so report these errors manually.
    if (this.error.statusCode === 404) {
      this.$appInsights.trackException({
        exception: new Error('Page not found'),
        properties: {
          statusCode: this.error.statusCode,
          message: this.error.message,
          fullPath: this.$route.fullPath
        }
      });
    }
  }
});
